import ClientReviewCardNew, { ClientReviewCardNewProps } from './ClientReviewCardNew';

export type { ClientReviewCardNewProps };
export default ClientReviewCardNew;
